// extracted by mini-css-extract-plugin
export default {"colors":"\"../styles/colors.css\"","primaryColor":"#3A237B","linkButton":"LinkButton_linkButton__wy0F5"};